import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../views/Home/Home";
import PrivatePolicy from "../views/Private-Policy/Private-Policy";
import AboutPage from "../views/About/About";
import ContactPage from "../views/Contact/Contact";
import NotFound from "../views/NotFound/NotFound";
import WorkInProgress from "../views/WorkInProgress/WorkInProgress";
import GalleryPage from "../views/Gallery/GalleryPage";
import ServicesPage from "../views/Services/Services";
import TermsAndConditions from "../views/TermsAndConditions/TermsAndConditions";

function Router() {
  const location = useLocation();
  useEffect(() => {
    window.scroll({ top: 0 });
  }, [location]);

  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/private-policy" element={<PrivatePolicy />} />
      <Route
        exact
        path="/frequently-asked-questions"
        element={<WorkInProgress />}
      />
      <Route
        exact
        path="/terms-and-conditions"
        element={<TermsAndConditions />}
      />
      <Route exact path="/private-policy" element={<PrivatePolicy />} />
      <Route exact path="/about" element={<AboutPage />} />
      <Route exact path="/contact" element={<ContactPage />} />
      <Route exact path="/request-proposal" element={<WorkInProgress />} />
      <Route exact path="/services" element={<ServicesPage />} />
      <Route exact path="/gallery" element={<GalleryPage />} />
      <Route exact path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Router;
